import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { getSetting } from "../../actions/Utils";
import { getCategoryNews } from '../actions/Publication'
import { Link } from 'react-router-dom';
class Sitemap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            path: '',
            slug: ''
        };
    }
    componentDidMount = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        var slug = this.props.match.path;
        if (slug.charAt(0) == '/') {
            slug = slug.substring(1, slug.length);
        }

        const requestData = {
            page: 1
        }

        const req = this.props.getCategoryNews(slug, requestData).then((data) => {
            this.setState({
                content: data,
                slug: slug
            })
        });
    }

    render() {

        const sitemap = this.state.content;
        // console.log(" content =",this.state.content);
        return (
            <Fragment>
                <section className="news-bulletin">

                    <div className="container">

                        <div className="news-bulletin-title">


                            <h1>{this.state.slug}</h1>


                            <hr />

                        </div>



                        <ul className="icab-sitemap">

                        {sitemap.length>0 && <Fragment>
                            {sitemap.map((row, key) => {
                                return (
                                    <Fragment key={key}>
                                        <li>


                                            <Link to={{ pathname: '/'+row.slug }}>{row.title} </Link>
                                            {row.submenu.length > 0 && <ul>
                                                {row.submenu.map((srow, skey) => {
                                                    return (
                                                        <Fragment key={skey}>
                                                           <li key={skey}>
                                                                <Link to={{ pathname: '/'+srow.slug }}>{srow.title}</Link>
                                                            </li>
                                                           
                                                        </Fragment>
                                                    )
                                                })}
                                            </ul>}


                                        </li>

                                    </Fragment>
                                )
                            })}
                        </Fragment>}
                    </ul>



                </div>

            </section>
            </Fragment >
        );
    }
}

const mapStateToProps = state => ({
    utils: state.utils,
})

const mapDispatchToProps = dispatch => ({
    getSetting: () => dispatch(getSetting()),
    getCategoryNews: (slug, requestData) => dispatch(getCategoryNews(slug, requestData)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sitemap));